(function () {
  'use strict';

  angular
    .module('compare.checkbox', [])

    /* @ngInject */
    .directive('compareCheckbox', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          id: '<idProduct',
          img: '<productImg',
          designation: '@productDesignation',
          titleAdd: '@',
          titleRemove: '@'
        },
        /* @ngInject */
        controller: ["$scope", "toastr", "CompareService", function ($scope, toastr, CompareService) {
          var ctrl = this,
            unwatch,
            unwatchEvent;

          ctrl.$onInit = function () {
            getChecked();
          };

          ctrl.$onDestroy = function () {
            if (unwatch !== null) {
              unwatch();
            }
            if (unwatchEvent !== null) {
              unwatchEvent();
            }
          };

          unwatch = $scope.$watch('checked', function (value) {
            if (!ctrl.init) {
              ctrl.init = true;
              return;
            }
            if (value) {
              CompareService.add(ctrl.id, ctrl.img);
              toastr.success(ctrl.designation, ctrl.titleAdd, {
                allowHtml: true,
                extraData: {
                  template: 'toast_comparator.tpl',
                  data: {
                    img: ctrl.img
                  }
                }
              });
            } else {
              if (!ctrl.products.length) return;
              CompareService.remove(ctrl.id, ctrl.img);
              toastr.success(ctrl.designation, ctrl.titleRemove, {
                allowHtml: true,
                extraData: {
                  template: 'toast_comparator.tpl',
                  data: {
                    img: ctrl.img
                  }
                }
              });
            }
            $scope.$emit('comparatorCheckboxUpdate');
          });

          unwatchEvent = $scope.$on('comparatorUpdate', function () {
            getChecked();
          });

          // Functions

          function getChecked() {
            ctrl.products = CompareService.get();
            $scope.checked = ctrl.products.indexOf(ctrl.id) !== -1;
          }

        }],
        controllerAs: 'ctrl'
      };
    });

})();
